import { Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

export const swiperConfig: SwiperOptions = {
  modules: [Autoplay],
  navigation: true,
  spaceBetween: 25,
  slidesPerView: 5,
  allowTouchMove: false,
  centeredSlides: true,
  loop: true,
  noSwipingClass: 'swiper-slide',
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 4000,
  breakpoints: {
    1024: {
      slidesPerView: 8,
      spaceBetween: 0,
    },
  },
};
